var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Message } from './Message';
var Thread = /** @class */ (function (_super) {
    __extends(Thread, _super);
    function Thread() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.subject = null;
        _this.latestMessage = null;
        _this.messages = null; // Only present when getting specific thread
        return _this;
    }
    var _a;
    __decorate([
        Type(Message),
        __metadata("design:type", typeof (_a = typeof Message !== "undefined" && Message) === "function" ? _a : Object)
    ], Thread.prototype, "latestMessage", void 0);
    __decorate([
        Type(Message),
        __metadata("design:type", Array)
    ], Thread.prototype, "messages", void 0);
    return Thread;
}(Entity));
export { Thread };
